import { Grid, Tab, Tabs } from "@mui/material";
import React from "react";
import { TabPanel, tabPropsFunc } from '../../../Base/Account/Account';
import { MonitoringProgress } from "./MonitoringProgress/MonitoringProgress";
import { ScorecardAtom } from "../../../../State/Scorecard.Atom";
import { DisputeResolutions } from "./DisputeResolutions/DisputeResolutions";
import { SeniorManagers } from "./SeniorManagers/SeniorManagers";
import { eeScorecardRoute } from "../../../../Component/Common/Constants/routes";
import { useRecoilValue } from "recoil";
import { PrescribedMatters } from "./PrescribedMatters/PrescribedMatters";


export const AdditionalBase = () => {
    const [tabValue, setTabValue] = React.useState<number>(0);

    const handleTabValueChanged = (event: React.SyntheticEvent, newValue: number) => {
        setTabValue(newValue);
    }

    const scorecard = useRecoilValue(ScorecardAtom);

    return (
        <Grid container>
            <Grid item xs={12}>
                <Tabs value={tabValue} onChange={handleTabValueChanged} aria-label="Tabs" centered>
                    <Tab label="Monitoring Progress" {...tabPropsFunc(0)} />
                    <Tab label="Dispute Resolutions" {...tabPropsFunc(1)} />
                    <Tab label="Senior Managers" {...tabPropsFunc(2)} />
                    <Tab label="Prescribed Matters" {...tabPropsFunc(3)} />
                </Tabs>
                <TabPanel value={tabValue} index={0}>
                    <MonitoringProgress />
                </TabPanel>
                <TabPanel value={tabValue} index={1}>
                    <DisputeResolutions scorecardId={scorecard.scorecardId} />
                </TabPanel>
                <TabPanel value={tabValue} index={2}>
                    <SeniorManagers scorecardId={scorecard.scorecardId} />
                </TabPanel>
                <TabPanel value={tabValue} index={3}>
                    <PrescribedMatters scorecardId={scorecard.scorecardId} />
                </TabPanel>
            </Grid>
        </Grid>
    )
}